var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"scroll-top-btn-wrapper"},[_c('div',{staticClass:"scroll-top-btn",on:{"click":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_vm._v(" Наверх ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }